import {useMutation} from '@tanstack/react-query';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {CustomPost} from '../custom-post';
import {apiClient, queryClient} from '@common/http/query-client';
import {showHttpErrorToast} from '@common/utils/http/show-http-error-toast';
import {DatatableDataQueryKey} from '@common/datatable/requests/paginated-resources';
import {toast} from '@common/ui/toast/toast';
import {message} from '@common/i18n/message';

interface Response extends BackendResponse {
  page: CustomPost;
}

export interface CreatePostPayload {
  title?: string;
  content?: string;
  featured_image?: string;
  project_id?: number;
  category_id?: number;
  meta_title?: string;
  meta_description?: string;
  meta_keywords?: string;
  excerpt?:string;
  status?:string;
  categories?: { value: number; label: string }[];
}

export function useCreatePost(endpoint?: string) {
  const finalEndpoint = endpoint || 'blogs/create';
  return useMutation({
    mutationFn: (payload: CreatePostPayload) =>
      createPost(payload, finalEndpoint),
    onError: err => showHttpErrorToast(err),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ['posts']});
      await queryClient.invalidateQueries({
        queryKey: DatatableDataQueryKey(finalEndpoint),
      });
      toast(message('Blog post created'));
    },
  });
}

function createPost(
  payload: CreatePostPayload,
  endpoint: string,
): Promise<Response> {
  return apiClient.post(`${endpoint}`, payload).then(r => r.data);
}
